import { NodeViewWrapper, type ReactNodeViewProps } from '@tiptap/react';
import isEmpty from 'lodash/isEmpty';
import { useSyncExternalStore } from 'react';

import { readTemplateTagLabel, readTemplateTagToken } from '@ui/components/editor/templateTagUtils';
import { cn } from '@ui/lib/utils';

const TITLE_SEPARATOR = '\n';

const TemplateTagNodeView = ({ editor, node, selected }: ReactNodeViewProps) => {
  const store = editor.storage.templateTag;
  const { tags, isTokenAvailable, unavailableTitle } = useSyncExternalStore(store.subscribe, store.getConfiguration);

  const token = readTemplateTagToken(node);
  const available = isTokenAvailable(token);
  const title = available || isEmpty(unavailableTitle) ? token : [token, unavailableTitle].join(TITLE_SEPARATOR);

  return (
    <NodeViewWrapper
      as="span"
      data-slot="template-tag"
      data-available={available}
      title={title}
      contentEditable={false}
      className={cn(
        'mx-px rounded-sm px-1 py-px whitespace-nowrap',
        available ? 'bg-accent-soft text-primary' : 'bg-destructive/10 text-destructive',
        selected && 'ring-2 ring-ring/50'
      )}
    >
      {readTemplateTagLabel(tags, token)}
    </NodeViewWrapper>
  );
};

export { TemplateTagNodeView };
